const data = '?work=first'
export default data;
